import { invoiceTypeDtoToInvoiceType } from '~/credsystem/mappers/invoice';
import { apiCredSystemInvoices } from '~/credsystem/services/apiCredSystem';

export async function getCredsystemCardInvoiceData(): Promise<
  StatementType[] | null
> {
  try {
    const response = await apiCredSystemInvoices.get<StatementTypeDto[]>(
      `/extrato/api/v1/resumo/cliente`
    );

    return response.data.reverse().map(invoiceTypeDtoToInvoiceType);
  } catch (error) {
    return null;
  }
}
